var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.loading
      ? _c("div", [
          _vm.view == "purple"
            ? _c("div", { staticClass: "new-home" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      class: {
                        "col-12": true,
                        "cover-background-image": true,
                        "new-search-box": true,
                        "search-box-container": true
                      }
                    },
                    [
                      _c("search-box", {
                        attrs: {
                          title: "st_public.email-box-title",
                          placeholder: "st_public.email-search-box-placeholder",
                          type: _vm.type
                        },
                        on: { loading: _vm.startLoading }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "row  " }, [
                  _c(
                    "div",
                    { staticClass: "col-12 text-center" },
                    [
                      _c("h1", { staticClass: "h2" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("trans")(
                              "st_public.search_by_email_text_header"
                            )
                          )
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("trans")(
                                "st_public.search_by_email_text_body"
                              )
                            ) +
                            "\n                    "
                        )
                      ]),
                      _c("testimonial")
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm.view == "green"
            ? _c(
                "div",
                { staticClass: "new-home" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        class: {
                          "col-12": true,
                          "cover-background-image": true,
                          "who-search-box": true,
                          "search-box-container": true
                        }
                      },
                      [
                        _c("search-box", {
                          attrs: {
                            title: "st_public.email-box-title",
                            placeholder:
                              "st_public.email-search-box-placeholder",
                            type: _vm.type
                          },
                          on: { loading: _vm.startLoading }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-5 mx-auto p-mob-0" },
                      [
                        _c("div", { staticClass: "who-covered" }, [
                          _c("div", {}, [
                            _c("h1", { staticClass: "h2" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public.search_by_email_text_header"
                                  )
                                )
                              )
                            ]),
                            _c("p", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.search_by_email_text_body"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ])
                          ]),
                          _c("img", {
                            attrs: {
                              src: require("assets/img/who-covered.jpg")
                            }
                          })
                        ])
                      ]
                    )
                  ]),
                  _c("who-testimonial"),
                  _c("who-payment")
                ],
                1
              )
            : _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 cover-background-image find-by-email search-box-container"
                    },
                    [
                      _c("search-box", {
                        attrs: {
                          title: "st_public.email-box-title",
                          placeholder: "st_public.email-search-box-placeholder",
                          type: _vm.type
                        },
                        on: { loading: _vm.startLoading }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "row my-5" }, [
                  _c("div", { staticClass: "col-12 text-center" }, [
                    _c("h1", { staticClass: "h2" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            "st_public.search_by_email_text_header"
                          )
                        )
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm._f("trans")(
                              "st_public.search_by_email_text_body"
                            )
                          ) +
                          "\n                    "
                      )
                    ])
                  ])
                ])
              ])
        ])
      : _c(
          "div",
          [
            _c("loading-data", {
              attrs: { searchText: _vm.searchText, type: _vm.type },
              on: { loading: _vm.stopLoading }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77022bb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77022bb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/email-search.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-77022bb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/email-search.vue
// module chunks = 6